var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.233,
    cy: 19.4502,
    r: 18.75,
    fill: "#FDFDFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4797 28.5528V28.552H28.4844V21.6333C28.4844 18.2486 27.7503 15.6414 23.7637 15.6414C21.8473 15.6414 20.5612 16.6852 20.0361 17.6748H19.9807V15.9573H16.2008V28.552H20.1367V22.3156C20.1367 20.6736 20.4503 19.0858 22.499 19.0858C24.5176 19.0858 24.5477 20.9597 24.5477 22.4209V28.5528H28.4797Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78699 15.9727H13.7276V28.5673H9.78699V15.9727Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7654 9.7002C10.5054 9.7002 9.48303 10.715 9.48303 11.9656C9.48303 13.2161 10.5054 14.2521 11.7654 14.2521C13.0253 14.2521 14.0477 13.2161 14.0477 11.9656C14.0469 10.715 13.0245 9.7002 11.7654 9.7002V9.7002Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.fa08c555f29d8900e48eb5d3e585d880.svg";
export { ForwardRef as ReactComponent };